require("../../amcharts.js");

require("./responsive.min.js");